import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import LoadingButton from '@mui/lab/LoadingButton';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Doctor } from '../../../../../../entities/PrescriptionRenewal';
import { StepContent, StepTagRow, StepTagChip, StepTagLabel } from '../styled';
import { ObservationTitle, ObservationSubtitle, ReasonTextField, SubmitButtonRow } from './styled';
import { Typography } from '@mui/material';

type OrderFormStepProps = {
  doctors: Doctor[];
  selectedDoctorId: string;
  description: string;
  onDescriptionChange: (value: string) => void;
  onDoctorChange: (doctorId: string) => void;
  onSubmit: () => void;
  canSubmit: boolean;
  isSubmitting: boolean;
};

export default function PrescriptionRenewalFormStep({
  doctors,
  selectedDoctorId,
  description,
  onDescriptionChange,
  onDoctorChange,
  onSubmit,
  canSubmit,
  isSubmitting
}: OrderFormStepProps) {
  return (
    <StepContent>
      <StepTagRow>
        <StepTagChip>
          <StepTagLabel>2 de 2</StepTagLabel>
        </StepTagChip>
        <StepTagLabel>Dados do pedido</StepTagLabel>
      </StepTagRow>

      <FormControl fullWidth variant="standard">
        <Select displayEmpty value={selectedDoctorId} onChange={event => onDoctorChange(event.target.value as string)}>
          <MenuItem value="" disabled>
            <Typography variant="body1">Selecione a médica</Typography>
          </MenuItem>
          {doctors.map(doctor => (
            <MenuItem key={doctor.id} value={doctor.id}>
              <Typography variant="body1">{doctor.name}</Typography>
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <div>
        <ObservationTitle>Campo de observação</ObservationTitle>
        <ObservationSubtitle>
          Escreva uma mensagem para a médica justificando seu pedido e ajudando ela a entender/relembrar seu caso:
        </ObservationSubtitle>
      </div>

      <ReasonTextField
        multiline
        minRows={4}
        value={description}
        placeholder="Oi Dra! Essa é a terceira solicitação que combinamos para o tratamento de  suplementação de ferro da minha gestação. Abs."
        onChange={event => onDescriptionChange(event.target.value)}
      />

      <SubmitButtonRow>
        <LoadingButton
          variant="contained"
          color="primary"
          endIcon={<ArrowForwardIcon />}
          disabled={!canSubmit}
          loading={isSubmitting}
          onClick={onSubmit}
        >
          Enviar pedido
        </LoadingButton>
      </SubmitButtonRow>
    </StepContent>
  );
}
